// ** Dropdowns Imports
import IntlDropdown from './IntlDropdown'
import CartDropdown from './CartDropdown'
import UserDropdown from './UserDropdown'
import NavbarSearch from './NavbarSearch'
import NotificationDropdown from './NotificationDropdown'
import AccountHeaderDropdown from './AccountHeaderDropdown'
import './navbarUser.scss'
// ** Third Party Components
import { Sun, Moon, Monitor, Server } from 'react-feather'

// ** Reactstrap Imports
import { NavItem, NavLink } from 'reactstrap'


// ** image import 
import img1 from '../../../../assets/images/manual/unlink-account.png'
import img2 from '../../../../assets/images/manual/trade_subscription.png'
import img3 from '../../../../assets/images/manual/bell-notification.png'

// ** custom compo
import { ImgTag } from '../../../../views/components/HtmlComp'
import { useDispatch, useSelector } from 'react-redux'
import { getAngelOne, getHeaderDeatils } from '../../../../views/pages/Home/store'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Modals from '../../../../views/components/modal'

const NavbarUser = props => {
  // ** Props
  const { skin, setSkin } = props

  // ** Function to toggle Theme (Light/Dark)
  const ThemeToggler = () => {
    if (skin === 'dark') {
      return <Sun className='ficon' onClick={() => setSkin('light')} />
    } else {
      return <Moon className='ficon' onClick={() => setSkin('dark')} />
    }
  }
  const userData = JSON.parse(localStorage.getItem('userData'));
  const {pathname} = useLocation()
  const dispatch = useDispatch()
  const navigate= useNavigate()
  const headerDetails = useSelector((store)=>store?.home?.headerDetails)
  const [type, setType] = useState('')
  const [showModal, setShowModal] = useState(false)


  
const toggle = () => {
  setShowModal(!showModal)   
}

const handleType= async()=>{
  if(headerDetails?.robo_active === 0) { setType('RoboActive'); setShowModal(true)  }
  else{
  headerDetails?.brokeraccount_status && await dispatch(getAngelOne())
  setType( 'AngleLinkForm')
  setShowModal(true)   
  }
}



useEffect(()=>{
  userData !== null &&  dispatch(getHeaderDeatils())
  },[])

  useEffect(() => {        
    if(pathname)
    {
      if(headerDetails?.onboarding_step < 5 && pathname != '/home/profile') { 
        // console.log('pthos',pathname)
        navigate('/home/profile')
      }  
    }
  }, [headerDetails,pathname])

  return (
    <>
    <ul className='nav navbar-nav align-items-center ms-auto'>
      <div className="navbarUser">
       
        {/* <div className='d-flex flex-column align-items-center' onClick={()=>navigate('/alerts-and-notification')}>
          <div className="d-flex">
            <ImgTag url={img3} />
            <h3 className='ms-1 mb-0'>{headerDetails?.notification_count}</h3>
            </div>
          <p className='mb-0'>Alert & Notifications</p>
        </div> */}
        
        <UserDropdown connected={headerDetails?.isConnected | 0} />
      </div>
    </ul>
      <Modals toggle={toggle} showModal={showModal} type={type} />
    </>
      )
}
export default NavbarUser
